import { Pipe, PipeTransform } from '@angular/core';
import { FilePurpose } from '@workspace/data-types';
import { CoreNiceLabelUtils } from '../core-nice-label.utils';

@Pipe({
  name: 'filePurposeDisplay',
})
export class FilePurposeDisplayPipe implements PipeTransform {
  transform(purpose: FilePurpose): string {
    return filePurposeDisplayTransform(purpose);
  }
}

export function filePurposeDisplayTransform(value: FilePurpose) {
  return CoreNiceLabelUtils.filePurpose(value);
}
